import introJs from 'intro.js'
export const intro = introJs()
  .setOptions({
    steps: [
      {
        element: '#appTitle',
        intro: 'JSON2LD Mapperは、JSONデータを元に、それに適したJSON-LDの作成を支援します'
      },
      {
        element: '#directInput',
        intro: 'チュートリアル用にサンプルのJSONをセットしました。直接編集することも可能です'
      },
      {
        element: '#uploadJson',
        intro: 'JSON-LDに変換したい手元のJSONファイルをアップロードしてください'
      },
      {
        element: '#selectExample',
        intro: 'あるいは、サンプルから読み込むことも可能です'
      },
      {
        element: '#previewJSONLD',
        intro: '読み込まれたJSONは自動でJSON-LDに変換されます'
      },
      {
        element: '#downloadJSONLD',
        intro: '後は手元にJSON-LDをダウンロードするだけです。簡単ですね！'
      },
      {
        element: '#openJSONLDPlayground',
        intro: '作成したJSON-LDをJSON-LD Playgroundで開き、JSON-LDの様々な展開系を確認することもできます'
      },
      {
        element: '#uploadPrimaryContext',
        intro: 'JSON-LD Contextが手元にある場合は、アップロードして差し替えることも可能です'
      },
      {
        element: '#selectPrimaryContext',
        intro: 'あるいは、基本とするContextを切り替えることもできます'
      },
      {
        element: '#mapping',
        intro: 'JSONのキーごとに任意のプロパティ、型、@id、@typeなどを指定できます'
      },
      {
        element: '#loginWithGithub',
        intro: 'Githubアカウントでログインすると、作成したContextをGistに保存したり、読み込んで再利用できます'
      },
    ],
    'doneLabel': '終了',
    'nextLabel': '次へ',
    'prevLabel': '前へ',
  })



// WEBPACK FOOTER //
// ./src/intro.js